import React from 'react'

import classes from './styles'

class MistakeCount extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showAnimation: false,
    }

    this.timeoutId = null
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.counter === this.props.counter) return

    this.setState({ showAnimation: true })

    this.timeoutId = setTimeout(() => {
      this.setState({ showAnimation: false })
    }, 200)
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeoutId)
  }

  render() {
    const { counter } = this.props
    const animationClass = this.state.showAnimation ? classes.animation + '  shake shake-constant' : ''

    return (
      <span className={animationClass}>
        {counter}
      </span>
    )
  }
}

MistakeCount.propTypes = {}

export default MistakeCount


// WEBPACK FOOTER //
// ./src/components/MistakeCount/MistakeCount.jsx